import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 导入所有语言的翻译文件
import enTranslation from './locales/en.json';
import zhTranslation from './locales/zh.json';
import zhTWTranslation from './locales/zh-TW.json';
import koTranslation from './locales/ko.json';
import jaTranslation from './locales/ja.json';
import arTranslation from './locales/ar.json';

// 定义支持 RTL 的语言
const RTL_LANGUAGES = ['ar'];

// 定义所有支持的语言
const SUPPORTED_LANGUAGES = ['en', 'zh', 'zh-TW', 'ko', 'ja', 'ar'];

// 从localStorage获取保存的语言设置
const savedLanguage = localStorage.getItem('language');

// 如果没有保存的语言设置，或者保存的语言不在支持列表中，使用浏览器语言或默认语言
let initialLanguage = 'zh'; // 默认语言

if (savedLanguage && SUPPORTED_LANGUAGES.includes(savedLanguage)) {
  initialLanguage = savedLanguage;
} else {
  // 尝试检测浏览器语言
  const browserLang = navigator.language.split('-')[0];
  if (SUPPORTED_LANGUAGES.includes(browserLang)) {
    initialLanguage = browserLang;
  } else if (browserLang === 'zh') {
    // 对于中文特殊处理，检查是否是繁体地区
    const fullLang = navigator.language;
    if (fullLang === 'zh-TW' || fullLang === 'zh-HK') {
      initialLanguage = 'zh-TW';
    } else {
      initialLanguage = 'zh';
    }
  }
}

const resources = {
  en: {
    translation: enTranslation,
  },
  zh: {
    translation: zhTranslation,
  },
  'zh-TW': {
    translation: zhTWTranslation,
  },
  ko: {
    translation: koTranslation,
  },
  ja: {
    translation: jaTranslation,
  },
  ar: {
    translation: arTranslation,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage, // 使用确定的初始语言
    fallbackLng: 'en', // 回退语言
    interpolation: {
      escapeValue: false,
    },
  });

// 监听语言变化，更新文档方向并保存到localStorage
i18n.on('languageChanged', (lng) => {
  console.log('Language changed to:', lng);
  
  // 设置文档方向
  const dir = RTL_LANGUAGES.includes(lng) ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  
  // 保存语言设置到localStorage
  localStorage.setItem('language', lng);
});

export default i18n; 